module.exports = __webpack_public_path__ + "static/img/wdgc2x-BcOQNpLb.f495325.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/wdgc2x-BcOQNpLb.png
// module id = 29sh
// module chunks = 16